import { render, staticRenderFns } from "./DisplayCouponList.vue?vue&type=template&id=259fb5ae&scoped=true&"
import script from "./DisplayCouponList.vue?vue&type=script&lang=ts&"
export * from "./DisplayCouponList.vue?vue&type=script&lang=ts&"
import style0 from "./DisplayCouponList.vue?vue&type=style&index=0&id=259fb5ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259fb5ae",
  null
  
)

export default component.exports